import { createClient, safeRequest } from '../clientConfiguration';

export const tosApiClient = createClient({
  baseURL: '/rest-api/team/v1',
});

export const userTeamMapping = ({ corpAcctNbr, body }) => {
  return safeRequest(() =>
    tosApiClient.patch(`/corp-accounts/${corpAcctNbr}/teams`, body),
  );
};

export const getTeamMapping = (corpAcctNbr: string, userId) => {
  return safeRequest(() =>
    tosApiClient.get(`/corp-accounts/${corpAcctNbr}/teams`, {
      params: { userId },
    }),
  );
};
